import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=b6e54d14&scoped=true&"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetails.vue?vue&type=style&index=0&id=b6e54d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e54d14",
  null
  
)

export default component.exports